import { HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

import { rendaVariavelBuy, rendaVariavelSell } from '../../colors';

interface BuySellHeaderProps {}

export const BuySellHeader: React.FC<BuySellHeaderProps> = () => {
  return (
    <HStack space={Spacing['inline.quarck']} alignItems="center">
      <HStack
        flex={1}
        borderRadius={BoxRadius.sm}
        py={Spacing['inset.nano']}
        px={Spacing['stack.xxxs']}
        bg={rendaVariavelBuy}
        alignItems="center"
        justifyContent="space-between">
        <Text
          variant="semibold"
          fontSize={Typography['fontsize.xs']}
          color={Color['neutral.white']}>
          Quantidade
        </Text>
        <Text
          variant="semibold"
          fontSize={Typography['fontsize.xs']}
          color={Color['neutral.white']}>
          Compram
        </Text>
      </HStack>
      <HStack
        flex={1}
        borderRadius={BoxRadius.sm}
        py={Spacing['inset.nano']}
        px={Spacing['stack.xxxs']}
        bg={rendaVariavelSell}
        alignItems="center"
        justifyContent="space-between">
        <Text
          variant="semibold"
          fontSize={Typography['fontsize.xs']}
          color={Color['neutral.white']}>
          Vendem
        </Text>
        <Text
          variant="semibold"
          fontSize={Typography['fontsize.xs']}
          color={Color['neutral.white']}>
          Quantidade
        </Text>
      </HStack>
    </HStack>
  );
};
